import { Redirect, Route, Switch } from 'react-router-dom'

import { Login } from '@src/pages/Login/Login'
import { Registration } from '@src/pages/Registration/Registration'
import { RecoveryPassword } from '@src/pages/RecoveryPassword/RecoveryPassword'
import { UserPage } from '@src/pages/UserPage/UserPage'
import { ChangeTariff } from '@src/pages/ChangeTariff/ChangeTariff'
import { Tariff } from '@src/pages/Tariff/Tariff'
import { MyTariffPlan } from '@src/components/MyTariffPlan/MyTariffPlan'
import { Payments } from '@src/pages/Payments/Payments'
import { BlockService } from '@src/pages/BlockService/BlockService'
import { Subscriptions } from '@src/pages/Subscriptions/Subscriptions'
import { AdditionalServices } from '@src/pages/AdditionalServices/AdditionalServices'
import { PaymentMethods } from '@src/pages/PaymentMethods/PaymentMethods'
import { ProfilePage } from '@src/pages/MyProfile/ProfilePage'
import { ChangePassword } from '@src/pages/ChangePassword/ChangePassword'
import { MovingNewAddress } from '@src/pages/MovingNewAddress/MovingNewAddress'
import { TerminationAgreement } from '@src/pages/TerminationAgreement/TerminationAgreement'
import { Error404 } from '@src/pages/Errors/Error404'
import { PrivateRoute } from '@src/routes/PrivateRoute'
import { Pay } from '@src/pages/Pay/Pay'
import { Account } from '@src/pages/Account/Account'
import { UserPageGame } from '@src/pages/UserPageGame/UserPageGame'
import { Messages } from '@src/pages/Messages/Messages'

export const Routes = () => (
  <Switch>
    <PrivateRoute exact path="/">
      <UserPage />
    </PrivateRoute>

    {/* Логин */}
    <Route exact path="/login">
      <Redirect to="/login/contract" />
    </Route>
    <Route exact path="/login/:type?" component={Login} />

    {/* Регистрация */}
    <Route exact path="/registration">
      <Redirect to="/registration/phone" />
    </Route>
    <Route path="/registration/:type?" component={Registration} />

    {/* Забыли пароль */}
    <Route exact path="/recovery-password">
      <Redirect to="/recovery-password/contract" />
    </Route>
    <Route path="/recovery-password/:type?" component={RecoveryPassword} />
    {/* Мой профиль */}
    <PrivateRoute path="/my-profile" component={ProfilePage} />
    {/* <Route path="/payments" component={Login} /> */}
    <PrivateRoute path="/change-tariff/:serviceId" component={ChangeTariff} />
    <PrivateRoute path="/tariff/:id" component={Tariff} />
    <PrivateRoute path="/my-tariff" component={MyTariffPlan} />
    {/* Платежи и списание */}
    <PrivateRoute exact path="/payments" component={Payments} />
    {/* Сообщения */}
    <PrivateRoute exact path="/messages" component={Messages} />
    {/* <Route path="/add-service" component={'AddService'} /> */}
    <PrivateRoute isNotSubscriber exact path="/block-service" component={BlockService} />
    {/* Подписки */}
    <PrivateRoute isNotSubscriber path="/subscriptions" component={Subscriptions} />
    {/* Дополнительные услуги */}
    <PrivateRoute path="/additional-services/:serviceId" component={AdditionalServices} />
    {/* Способы оплаты */}
    <PrivateRoute exact path="/payment-methods">
      <Redirect to="/payment-methods/erip" />
    </PrivateRoute>
    <PrivateRoute path="/payment-methods/:type?" component={PaymentMethods} />
    {/* Смена пароля */}
    <PrivateRoute isNotSubscriber path="/change-password" component={ChangePassword} />
    {/* Переезд */}
    <PrivateRoute isNotSubscriber path="/moving-new-address" component={MovingNewAddress} />
    {/* Расторжение договора */}
    <PrivateRoute isNotSubscriber path="/termination-agreement" component={TerminationAgreement} />
    <PrivateRoute isNotSubscriber exact path="/termination-agreement">
      <Redirect to="/termination-agreement/first-step" />
    </PrivateRoute>
    <PrivateRoute path="/reklamnaya-igra-kosmos-tv-30-let" component={UserPageGame} />
    <Route exact path="/pay" component={Pay} />
    <Route exact path="/account" component={Account} />
    <Route path="*" component={Error404} />
  </Switch>
)
